import { useContext, useEffect } from "react";
import styles from "./carousel.module.scss";
import CurrentContext from "../utils/CurrentContext";

export default function Carousel() {
  const { aspectRatio, quizImages, currentIndex } = useContext(CurrentContext);

  useEffect(() => {
    console.log("quizImages carousel", quizImages);
  }, [quizImages]);

  return (
    <div
      className={`${
        aspectRatio >= 1 ? styles.carousel : styles.carousel_potrait
      }`}
    >
      {Array.isArray(quizImages) &&
        quizImages.map((img, i) => (
          <div className={styles.thumbnail} key={i}>
            <div
              className={`${aspectRatio >= 1 ? styles.carousel_thumb: styles.carousel_thumb_potrait} ${
                i === currentIndex ? styles.active_thumb : ""
              }`}
              style={{ backgroundImage: `url(${img.src})` }}
            />
            <div
              className={`${styles.highlighter} ${
                i === currentIndex ? styles.active_thumb_bottom : ""
              }`}
            ></div>
          </div>
        ))}
    </div>
  );
}
